/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 11:09:09
 * @LastEditTime: 2022-06-01 16:03:30
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DeliveryMethod/config.tsx
 */

import { ExclamationCircleFilled } from '@ant-design/icons';
import React from 'react';
//import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { getCourierShow } from '../CourierAccount/tools';
import css from './css.module.less';

export const columns = (onDelete, onEdit, disabled, { getI18n }) => [
  {
    title: getI18n('storeLogistics.deliveryMethod.deliveryMethodName'),
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 224,
    childGenerate: (text, record, index) => {
      return (
        <div className={css.errorTr}>
          <span>{text}</span>
          {record.hasError && (
            <ExclamationCircleFilled className={css.draftNameErr} />
          )}
        </div>
      );
    },
  },
  {
    title: getI18n('storeLogistics.index.shippingZone'),
    dataIndex: 'shippingZone',
    default: true,
    key: 'shippingZone',
    minWidth: 192,
    childGenerate: (text, record, index) => {
      return text.name || '';
    },
  },
  {
    title: getI18n('storeLogistics.warehouseLocations.courierAccount'),
    dataIndex: ['courierAccount', 'name'],
    default: true,
    key: 'courierAccountName',
    minWidth: 192,
    // childGenerate: (text, record, index) => {
    //   return text.name || '';
    // },
  },
  {
    title: getI18n('storeLogistics.deliveryMethod.logisticVendor'),
    dataIndex: 'courierAccount',
    default: true,
    key: 'courierAccount',
    minWidth: 160,
    childGenerate: (text) => {
      return text ? getCourierShow(text) : '';
    },
  },
  {
    title: getI18n('storeLogistics.deliveryMethod.deliverySpeed'),
    dataIndex: 'shippingSpeed',
    default: true,
    key: 'shippingSpeed',
    minWidth: 160,
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 128,
    childGenerate: (text, record, index) =>
      !disabled ? (
        <div className={css.action}>
          <span className={css.danger} onClick={() => onDelete(record.uuid)}>
            {getI18n('general.delete')}
          </span>
          <span className={css.primary} onClick={() => onEdit(record.uuid)}>
            {getI18n('general.edit')}
          </span>
        </div>
      ) : null,
  },
];
